import axios from "axios";

export const API_URL = import.meta.env.VITE_API_URL ?? "https://backend-development-2.innovera.ai/api/v1";

const $api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

export default $api;
